module.exports = __webpack_public_path__ + "static/img/cell_phone_2.94dee9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/cell_phone_2.svg
// module id = wo9k
// module chunks = 0